<template>
    <tq-on-top-container id="test" :style="{maxWidth: p_maxWidth_s}">

        <div slot="body" class="lc_container">
            <tq-image  class="lc_backgroundImg "
                       :class="p_imageClass_s"
                       :height="p_height_s"
                       :pb_att_s="p_att_s +'_blur'"
                       :pb_src_r="pp_imgUrl_s" >
            </tq-image>
        </div>

        <tq-image  slot="middle" class="lc_mainImg"
                   :height="p_height_s"
                   :class="p_imageClass_s"
                   :pb_att_s="p_att_s" :pb_src_r="pp_imgUrl_s" ></tq-image>

    </tq-on-top-container>
</template>

<script>
    import TqOnTopContainer from "../basic/TqOnTopContainer";
    import TqImage from "../basic/TqImage";
    export default {
        name: "TqImgFillBlur",
        components: {TqImage, TqOnTopContainer},
        props:{
            p_height_s:{
                type: String,
                require: true
            },
            p_maxWidth_s:{
                type: String,
                default: '100%'
            },
            pp_imgUrl_s:{},
            p_imageClass_s:{
                type: String,
            },
            p_att_s:{
                validator: String,
                default: "TravelQuest"
            },
        },
    }
</script>

<style scoped>


    .lc_mainImg{

        background: transparent;
        width: 100%;
        object-fit: scale-down;
        object-position: 50% 50%;

    }


    .lc_container{
        overflow: hidden;
    }

    .lc_backgroundImg{
        /* The image used */

        /* Add the blur effect */
        filter: blur(10px);
        -webkit-filter: blur(10px);
        transform: scale(1.03);

        width: 100%;

        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }
</style>